/**
* Image Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'image-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.image-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--image-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '24px',
          autoWidth: true,
          perMove: 1,
          speed: 750,
        } );

        splide.mount();

        $( '.image-slider .splide__list' ).magnificPopup( {
          delegate: '.splide__slide a',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
          },
          image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function( item ) {
              return item.el.attr( 'data-image-caption' );
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-slider', COMPONENT );
} )( app );
